import type {SpaceW, Transitioning} from '@cohort/wallet/components/contexts/SpaceContext';
import SpaceContext from '@cohort/wallet/components/contexts/SpaceContext';
import {spacesKeys, useMerchantSpace} from '@cohort/wallet/hooks/api/Space';
import {useUserStore} from '@cohort/wallet/hooks/stores/user';
import {useQueryClient} from '@tanstack/react-query';
import {useState} from 'react';

const useSpace = (): SpaceW => {
  const [transitioning, setTransitioning] = useState<Transitioning>({
    active: false,
    enterFrom: 'left',
  });
  const user = useUserStore(store => store.user);
  const queryClient = useQueryClient();
  const {data: space} = useMerchantSpace(user !== null);

  const triggerRefresh = async (): Promise<void> =>
    queryClient.invalidateQueries(spacesKeys.getSpace());

  return {
    space,
    transitioning,
    setTransitioning,
    triggerRefresh,
  };
};

interface SpaceContextProviderProps {
  children: React.ReactNode;
}

const SpaceContextProvider = ({children}: SpaceContextProviderProps): JSX.Element => {
  const currentSpace = useSpace();
  return <SpaceContext.Provider value={currentSpace}>{children}</SpaceContext.Provider>;
};

export default SpaceContextProvider;
